import React from "react";
import { Alert } from "react-bootstrap";

const AnimatedWords = ({ list, setFieldValue }: { list: Array<any>; setFieldValue: any }) => {
  const removeAnimatedWord: any = (index: number) => {
    const newAnimatedWords = [...list];
    newAnimatedWords.splice(index, 1);
    setFieldValue("hero_animated_words", [...newAnimatedWords]);
  };

  return (
    <>
      {list?.length ? (
        <div className="d-flex flex-wrap gap-2 border p-3 rounded-3">
          {list?.map((item: any, index: number) => {
            return (
              <div key={item.name} className="d-flex align-items-center border p-2 rounded-3">
                <span className="rounded-circle" style={{ background: item.style, height: "20px", width: "20px" }}></span>
                <span className="fw-bold mx-2 text-capitalize">{item.name}</span>
                <i className="fa-solid fa-xmark text-danger" onClick={() => removeAnimatedWord(index)}></i>
              </div>
            );
          })}
        </div>
      ) : (
        <Alert variant="info">Please add some animated words</Alert>
      )}
    </>
  );
};

export default AnimatedWords;
